"use client";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@ui/components/core/Tooltip";
import { useTranslations } from "next-intl";

export function LoopTooltip({ children }: { children: React.ReactNode }) {
  const t = useTranslations("ClientKeys.TTSFX");
  return (
    <TooltipProvider>
      <Tooltip delayDuration={100}>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent className='shadow-xs'>
          <div className='f-paragraph-03 max-w-[300px]'>{t("widget.loop_description")}</div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
